"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _color = _interopRequireDefault(require("color"));

require("./Widget.scss");

var _WidgetGrid = _interopRequireDefault(require("./WidgetGrid"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Widget extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getThemeStyle", () => {
      const style = this.props.style;
      let backgroundColor = style.backgroundColor || "white";
      backgroundColor = (0, _color.default)(backgroundColor);
      let themeStyle;

      if (backgroundColor.isDark()) {
        themeStyle = "dark";
      } else {
        themeStyle = "light";
      }

      return themeStyle;
    });

    _defineProperty(this, "getStyle", () => {
      const _this$props = this.props,
            style = _this$props.style,
            cols = _this$props.cols,
            rows = _this$props.rows,
            area = _this$props.area;

      if (!style) {
        return false;
      }

      return style;
    });

    _defineProperty(this, "getClassName", () => {
      const _this$props2 = this.props,
            widgetType = _this$props2.widgetType,
            widgetSize = _this$props2.widgetSize;
      let classNames = [];
      classNames.push('admin-widget');

      if (widgetType) {
        classNames.push('admin-widget--' + widgetType);
      }

      return classNames.join(' ');
    });

    _defineProperty(this, "getSize", () => {
      const widgetSize = this.props.widgetSize;

      if (!widgetSize) {
        return {};
      }

      const sizes = {
        "xs": 2,
        "s": 4,
        "m": 8,
        "l": 12,
        "xl": 16
      };
      const grid = widgetSize.split(":");
      let cols = grid[0];
      let rows = grid[1];
      cols = sizes[cols] || parseInt(cols);
      rows = sizes[rows] || parseInt(rows);
      return {
        cols: cols,
        rows: rows
      };
    });
  }

  render() {
    const _this$props3 = this.props,
          id = _this$props3.id,
          expanded = _this$props3.expanded,
          selected = _this$props3.selected,
          style = _this$props3.style,
          widgetSize = _this$props3.widgetSize;

    const _this$getSize = this.getSize(),
          cols = _this$getSize.cols,
          rows = _this$getSize.rows;

    const themeStyle = this.getThemeStyle();
    const className = this.getClassName();
    return _react.default.createElement("div", {
      className: className,
      style: style,
      onClick: this.props.onClick,
      "data-theme": themeStyle,
      "data-size": widgetSize,
      "data-cols": cols,
      "data-rows": rows,
      "aria-expanded": expanded,
      "aria-selected": selected
    }, _react.default.createElement(_WidgetGrid.default, null, this.props.children));
  }

}

_defineProperty(Widget, "defaultProps", {
  id: "widget",
  expanded: false,
  selected: false,
  widgetType: undefined,
  widgetSize: "1:1",
  style: {}
});

var _default = Widget;
exports.default = _default;
module.exports = exports.default;